import { ANALYTICS_CHART_TYPE } from "@resources/Constants";

const SingleDigitChartTypes = [
  ANALYTICS_CHART_TYPE.CROWD_COUNTING,
  ANALYTICS_CHART_TYPE.SHOPPING_CARTS_IN_USE
];

export function formatAnalyticsValue(value: number, chartType: string): string {
  const isCumulativeOrOccupancy =
    chartType.includes("CUMULATIVE") || chartType.includes("OCCUPANCY");

  if (isCumulativeOrOccupancy || SingleDigitChartTypes.includes(chartType)) {
    return Math.ceil(value).toLocaleString();
  }

  return Number(value?.toFixed(1)).toLocaleString();
}

export const fixAnalyticsValue = (value: number, chartType: string): number => {
  const isCumulativeOrOccupancy =
    chartType.includes("CUMULATIVE") || chartType.includes("OCCUPANCY");

  if (isCumulativeOrOccupancy || SingleDigitChartTypes.includes(chartType)) {
    return Math.ceil(value);
  }

  return Number(value.toFixed(1));
};
